import 'babel-polyfill';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/css/common.css';

function init() {
  const needDebug = false
  if (needDebug) {
    const script = document.createElement('script')
    script.src = 'https://cdn.bootcss.com/vConsole/3.3.4/vconsole.min.js'
    document.body.appendChild(script)
    script.onload = () => {
      // eslint-disable-next-line
      const vconsole = new VConsole()
    }
  }
}
init()
createApp(App).use(router).mount('#app');
